const AppLoading = ({ children }) => (
    <div className="app-loading" role="status" aria-live="polite">
        <span className="app-loading__card btn btn-primary">{children}</span>
    </div>
);

export default AppLoading;
